//imports
import {
    MESSAGE_TEMPLATE_DELETE_OPEN_MODAL,
    MESSAGE_TEMPLATE_DELETE_REQUEST,
    MESSAGE_TEMPLATE_DELETE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    messageTemplate: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MESSAGE_TEMPLATE_DELETE_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, messageTemplate: action.payload.messageTemplate }

        case MESSAGE_TEMPLATE_DELETE_REQUEST:
            return { ...state, loading: true }

        case MESSAGE_TEMPLATE_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "MESSAGE_TEMPLATE_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};